<template>
  <div class="d-flex flex-column" :style="cardStyle">
    <section class="d-flex align-center flex-grow-1" :class="isFullScreen ? 'px-0' : 'px-2'">
      <div style="width: 100%; height: 100%">
        <InscritosTextView
          :count="formattedCount"
          :posicao-card="posicaoCard"
        />
      </div>
    </section>
  </div>
</template>

<script>
import InscritosTextView from "@/components/Tarjas/GETV/InscritosTextView.vue";

export default {
  name: 'CardTarjaInscritosYoutube',
  components: {
    InscritosTextView,
  },
  props: {
    numInscritosYoutube: {
      type: Number,
      default: 0
    },
    posicaoCard: {
      type: String,
      default: 'centro',
      validator: (value) => ['esquerda', 'centro', 'direita'].includes(value)
    },
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      percentScreenDim: {
        maxWidth: 30,
        minWidth: 20,
        minHeight: 40,
        maxHeight: 70,
        fullScreenMaxWidth: 100,
        fullScreenMaxHeight: 100,
        fullScreenMinWidth: 100,
        fullScreenMinHeight: 100,
      },
    };
  },
  computed: {
    formattedCount() {
      if (!this.numInscritosYoutube && this.numInscritosYoutube !== 0) {
        return '0';
      }
      return this.numInscritosYoutube.toLocaleString('pt-BR');
    },
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    cardStyle() {
      let maxWidth, maxHeight, minWidth, minHeight;

      if (this.isFullScreen) {
        minWidth =
          (this.percentScreenDim.fullScreenMinWidth * this.screenDimensions.width) / 100;
        maxWidth =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100;
        minHeight =
          (this.percentScreenDim.fullScreenMinHeight * this.screenDimensions.height) / 100;
        maxHeight =
          (this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) / 100;

        return `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important;
                min-width: ${minWidth}px !important; min-height: ${minHeight}px !important;`;
      }

      const position =
        this.posicaoCard === 'esquerda'
          ? 'margin-left: 100px; justify-self: flex-start'
          : this.posicaoCard === 'centro'
          ? 'justify-self: center'
          : this.posicaoCard === 'direita'
          ? 'margin-right: 40px; justify-self: flex-end'
          : '';

      const dimensions = 'width: 640px; height: 160px;';

      let array = position
        .split(';')
        .concat(dimensions.split(';'))
        .filter((item) => item !== '');

      return array.filter((item) => item).join(';');
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  width: 100%;
}
</style>
